module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-altenergy.svg?46e7866cb3b3f90f57bbef533d4a7fb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-altenergy.svg
// module id = 1025
// module chunks = 1